import styled from "styled-components";
import { rgba } from "polished";
const CalendarOptionImpl = styled("div")(
  {
    alignItems: "center",
    borderRadius: 2,
    cursor: "pointer",
    display: "grid",
    textAlign: "center",
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba("white", 0.15)}`,
      outline: 0
    }
  },
  ({ $external }) => $external ? {
    color: "rgba(0, 0, 0, 0.45)"
  } : void 0,
  ({ $highlighted, $selected, theme }) => {
    if ($selected) {
      return {
        backgroundColor: $highlighted ? theme.color.blue2 : theme.color.blue1,
        color: theme.color.blue6,
        fontWeight: theme.fontWeight.medium,
        "&:active": {
          backgroundColor: theme.color.blue3
        }
      };
    }
    if ($highlighted) {
      return {
        backgroundColor: "#f5f5f5",
        "&:active": {
          backgroundColor: "#e8e8e8"
        }
      };
    }
    return void 0;
  }
);
export {
  CalendarOptionImpl
};
